module.exports = __webpack_public_path__ + "img/ar-lang.58e23683.svg";